import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { GravityQualifier } from "../GravityQualifier";
/**
 * @description The class for the FocusOn builder
 * @memberOf Qualifiers.Gravity
 * @extends {Qualifiers.Gravity.GravityQualifier}
 */

var FocusOnGravity = /*#__PURE__*/function (_GravityQualifier) {
  _inherits(FocusOnGravity, _GravityQualifier);

  var _super = _createSuper(FocusOnGravity);

  function FocusOnGravity(FocusOnObjects) {
    _classCallCheck(this, FocusOnGravity);

    // Required due to https://github.com/microsoft/TypeScript/issues/13029

    /* istanbul ignore next */
    return _super.call(this, FocusOnObjects);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */


  _createClass(FocusOnGravity, [{
    key: "fallbackGravity",
    value: function fallbackGravity(val) {
      /*
       *  FocusOnGravity(this) is already a qualifier, with a key and a value g_{obj1}
       *  fallBackGravity also attempts to add a value, to reach the result of g_{obj1}:auto:{obj2}
       *  Since AutoGravity is a Qualifier, it also comes with its own g_ key, which needs to be removed.
       *  To solve it, we take only the value from the qualifier, instead of the whole thing
       */
      this.addValue(val.qualifierValue);
      return this;
    }
  }]);

  return FocusOnGravity;
}(GravityQualifier);

export { FocusOnGravity };